module.exports = __webpack_public_path__ + "img/user15.10cbcff5.jpg";